var render, staticRenderFns
import script from "./coffeeType.vue?vue&type=script&lang=js"
export * from "./coffeeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03844e30')) {
      api.createRecord('03844e30', component.options)
    } else {
      api.reload('03844e30', component.options)
    }
    
  }
}
component.options.__file = "src/scripts/components/basic/coffeeType.vue"
export default component.exports